export default __webpack_public_path__ + "static/media/banner-hero-mob.96f9b60d.png";